// Public pages
import barbara from '../../modules/site/barbara/i18n/es';
import concept from '../../modules/site/concept/i18n/es';
import onlineCourse from '../../modules/site/onlineCourse/i18n/es';
import thankYou from '../../modules/site/thankYou/i18n/es';
import paymentFailure from '../../modules/site/paymentFailure/i18n/es';
import livecourse from '../../modules/site/livecourse/i18n/es';
import workbook from '../../modules/site/workbook/i18n/es';
import summary from '../../modules/site/summary/i18n/es';
import textbook from '../../modules/site/textbook/i18n/es';
import contact from '../../modules/site/contact/i18n/es';
import press from '../../modules/site/press/i18n/es';
import tc from '../../modules/site/tc/i18n/es';
import policies from '../../modules/site/policies/i18n/es';

// Common components
import nav from '../../components/nav/i18n/es';
import header from '../../components/header/i18n/es';
import footer from '../../components/footer/i18n/es';

export let i18nES = angular.extend({},

    // Common components and public pages
    nav,
    footer,
    header,
    barbara,
    concept,
    onlineCourse,
    thankYou,
    paymentFailure,
    livecourse,
    workbook,
    summary,
    textbook,
    contact,
    press,
    tc,
    policies

);



// WEBPACK FOOTER //
// ./client/app/core/i18n/i18n.es.files.js